import {
  ApplicationRef,
  Component,
  ElementRef,
  Inject,
  LOCALE_ID,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ITela} from "../../objeto/ITela";
import {PedidosService} from "../../services/pedidos.service";
import {CarrinhoService} from "../../services/carrinho.service";
import {PedidoLoja} from "../../objeto/PedidoLoja";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ModalEscolherEnderecoComponent} from "../modal-escolher-endereco/modal-escolher-endereco.component";
import {NgForm, NgModel} from "@angular/forms";
import {DominiosService} from "../../services/dominios.service";
import {ActivatedRoute, Router} from "@angular/router";
import {LojaCarrinhoComponent} from "../../loja-carrinho/loja-carrinho.component";
import {FormaDeEntrega} from "../../objeto/FormaDeEntrega";
import {ConstantsService} from "../../services/ConstantsService";
import {ClienteService} from "../../services/cliente.service";
import {EnderecoService} from "../../services/endereco.service";
import {FormaDePagamento} from "../../objeto/FormaDePagamento";
import {DialogCloseResult, DialogService} from "@progress/kendo-angular-dialog";
import {DeviceDetectorService} from "ngx-device-detector";
import {AutorizacaoLojaService} from "../../services/autorizacao-loja.service";
import {EnumMeioDePagamento} from "../../objeto/EnumMeioDePagamento";
import {PagseguroService} from "../../services/pagseguro.service";
import {TelaCartaoDeCreditoComponent} from "../tela-cartao-de-credito/tela-cartao-de-credito.component";
import {DadosCartao} from "../../objeto/DadosCartao";
import {SiteCampoAdicionalComponent} from "../site-campo-adicional/site-campo-adicional.component";
import {AdicionalUtils} from "../../objeto/AdicionalUtils";
import {DadosPix} from "../../objeto/DadosPix";
import {DropDownFilterSettings} from "@progress/kendo-angular-dropdowns";
import {formatCurrency, Location} from "@angular/common";
import {PainelLoginComponent} from "../painel-login/painel-login.component";
import {CadContatoLojaComponent} from "../cad-contato/cad-contato-loja.component";
import {MaskedTextBoxComponent} from "@progress/kendo-angular-inputs";
declare  var $;
declare var PagSeguroDirectPayment;
declare var fbq;
declare var gtag;

@Component({
  selector: 'app-finalizar-pedido',
  templateUrl: './finalizar-pedido.component.html',
  styleUrls: ['./finalizar-pedido.component.scss']
})
export class FinalizarPedidoComponent implements OnInit ,  ITela {
  @ViewChild('txtTrocoM') txtTrocoM: ElementRef;
  @ViewChild('frm', {static: true}) frm: NgForm;
  @ViewChild('panelCarrinho', {static: true}) panelCarrinho: LojaCarrinhoComponent;
  @ViewChild('txtEmailPix', {static: false}) txtEmailPix: ElementRef;
  @ViewChild('kendoMaskedTextBox', {static: false}) txtTelefone: MaskedTextBoxComponent;

  pedido: PedidoLoja = new PedidoLoja();
  empresa: any = {};
  selecionou: boolean;
  buscando: any;
  eviandoPedido: boolean;
  msgErro: string
  msg: string
  urlWhatsapp: string
  FormaDeEntrega = FormaDeEntrega;
  informarCpf: boolean;
  cpfObrigatorio: boolean;
  informarDataNascimento: boolean;
  dataNascimentoObrigatorio: boolean;
  criarConta: boolean;
  exibirSenha: boolean;
  formasDePagamento: Array<FormaDePagamento> = [];
  formasDePagamentoOnline: Array<FormaDePagamento> = [];
  formasDePagamentoPix: Array<FormaDePagamento> = [];
  enderecos = [];
  isMobile = false;
  agendarEntrega: boolean;
  dataEntrega: Date;
  agora: Date = new Date();
  horaEntrega: any;
  agendouEntrega: boolean;
  apenasAgendamento: any;
  cashback: any;
  msgErroPagSeguro = '';
  telaPagamento: TelaCartaoDeCreditoComponent;
  exigeCartao: boolean;
  dadosCartao: DadosCartao;
  valorTeste: any;
  camposAdicionais = [];
  formasDeEntrega = [];
  msgErroLink
  fidelidadeExterna: any;
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains'
  };
  @ViewChildren('adicionalComponent') ctrlAdicionais: QueryList<SiteCampoAdicionalComponent>;
  phoneMask = "(00) 00000-0000";
  numeroTelefone: any;

  constructor(private app: ApplicationRef, private pedidosService: PedidosService, private constantsService: ConstantsService,
              @Inject(LOCALE_ID) public locale: string,
              private activatedRoute: ActivatedRoute,      private location: Location,
              private  dominiosService: DominiosService, private router: Router, private clienteService: ClienteService,
              private  carrinhoService: CarrinhoService, private modalService: NgbModal,  private autorizacao: AutorizacaoLojaService,
              private  enderecoService: EnderecoService, private dialogService: DialogService,
              private detectorDevice: DeviceDetectorService, private pagseguroService: PagseguroService,
              private autorizacaoLojaService: AutorizacaoLojaService) {
  }

  ngOnInit() {
    this.isMobile = this.detectorDevice.isMobile();

    this.pedido = this.carrinhoService.obtenhaPedido();
    this.panelCarrinho.setModoPanel();

    this.carrinhoService.salvePedido(this.pedido);

    this.autorizacaoLojaService.sessao$.subscribe( (idSessao: string) => {
      if (typeof fbq !== 'undefined') {
        if (this.pedido && !this.pedido.disparouEventoIniciarCheckout) {
          this.pedido.disparouEventoIniciarCheckout = true;

          const idEvento = idSessao + '-' + new Date().getTime();
          this.carrinhoService.notifiqueInicioCheckout(this.pedido, idEvento);

          fbq('track', 'InitiateCheckout', {
            value: this.pedido.total,
            currency: 'BRL',
          }, {eventID: idEvento});
        }
      }
    });

    if (this.pedido.itens.length === 0) return this.abraTelaLoja();

    this.constantsService.empresa$.subscribe(data => {
      if (data) {
        this.empresa = data;
        this.apenasAgendamento = !this.empresa.estaRecebendoPedidos && this.empresa.permiteAgendamento
        this.empresa.apenasAgendamento = this.apenasAgendamento
        if(this.apenasAgendamento) this.agendarEntrega = true
        this.formasDeEntrega = this.obtenhaFormasDeEntrega(this.empresa.formasDeEntrega);

        if(this.empresa.integracaoFidelidade){
          this.fidelidadeExterna = Object.assign({},  this.empresa.integracaoFidelidade);

          if( !this.autorizacao.getUsuario()){
            this.fidelidadeExterna.aceitarFidelidade = true;
            this.fidelidadeExterna.optin = true;
          }
        }

        let formasAtivas = []

        for(let formaEntrega of this.formasDeEntrega)
          if(formaEntrega.ativa)
            formasAtivas.push(formaEntrega)

        if (formasAtivas.length === 1)
          this.pedido.entrega.formaDeEntrega = formasAtivas[0].nome;

        if(!this.apenasAgendamento)
          this.formasDeEntrega.forEach((formaDeEntrega: any) => {
            if( this.pedido.entrega.formaDeEntrega === formaDeEntrega.formaDeEntrega.nome ) {
              this.agendarEntrega = formaDeEntrega.agendamentoObrigatorio;
              this.apenasAgendamento = formaDeEntrega.agendamentoObrigatorio;
            }
          });

        this.empresa.formasDePagamento.forEach(formaDePagamento => {
          const formaDePagamentoPedido = this.pedido.pagamento.formaDePagamento;

          if( !formaDePagamento.exibirCardapio && !(formaDePagamentoPedido && formaDePagamentoPedido.id === formaDePagamento.id) )
            return;

          if( formaDePagamentoPedido && formaDePagamentoPedido.id === formaDePagamento.id ) {
            this.pedido.pagamento.formaDePagamento = formaDePagamento;
          }

          if( !formaDePagamento.online ) {
            this.formasDePagamento.push(formaDePagamento);
          } else if( formaDePagamento.pix ) {
            this.formasDePagamentoPix.push(formaDePagamento);
          } else {
            this.formasDePagamentoOnline.push(formaDePagamento);
          }
        });

        if(this.pedido.dataEntrega) {
          this.agendouEntrega = true
          this.agendarEntrega = true
        }

        this.setCashbackDoPagamento();

        if(this.pedido && this.pedido.pagamento)
          if(this.meioOnlineExigeCartao( this.pedido.pagamento.formaDePagamento))
            this.exigeCartao = true;

        if(this.pedido.gerarLinkPagamento) this.gereLinkPagamento();

        this.pedidosService.obtenhaAdicionaisPedido(this.empresa).then( (adicionais) => {
          this.camposAdicionais = adicionais;
          this.pedido.adicionais = {};
          this.pedido.camposAdicionais = adicionais;
          AdicionalUtils.prepareAdicionais(this.pedido, adicionais);
        });
      }
    })
    this.constantsService.campoCpf$.subscribe( campoCpf => {
      this.informarCpf = campoCpf != null;
      this.cpfObrigatorio = campoCpf && !campoCpf.opcional;
    });

    this.constantsService.campoDataNascimento$.subscribe( campoDataNascimento => {
      this.informarDataNascimento = campoDataNascimento != null;
      this.dataNascimentoObrigatorio = campoDataNascimento && !campoDataNascimento.opcional;
    });

    this.carrinhoService.alterouPedido.subscribe( (pedido) => {
       if(pedido && this.cashback) {
         let totalSemTaxa = pedido.obtenhaTotalSemTaxaEntrega();
         if (this.cashback.minimoPedido > totalSemTaxa) {
           this.setPodeUsarCashback(totalSemTaxa);
         } else {
           this.setValorCashbachUsar(totalSemTaxa);
           this.cashback.podeUsarNoPedido = true;
         }
       }

    })
  }

  setValorCashbachUsar(valorPedidoPagar){
    this.cashback.valor = this.cashback.saldo >  valorPedidoPagar ? valorPedidoPagar : this.cashback.saldo;
  }

  setPodeUsarCashback(valorPedidoPagar: number){
    if(!this.cashback) return;
    this.cashback.podeUsarNoPedido = valorPedidoPagar >= this.cashback.minimoPedido;
    if(this.cashback.usarPadrao)
      if(this.cashback.saldo)
        this.cashback.usar =   this.cashback.podeUsar &&   this.cashback.podeUsarNoPedido;

    this.setValorCashbachUsar(valorPedidoPagar);
    this.alterouUsarSaldo()
  }

  setCashbackDoPagamento(){
    delete this.cashback;
    delete this.pedido.cashback;
    if(this.empresa.integracaoPedidoFidelidade || this.empresa.integracaoDelivery){
      this.clienteService.obtenhaSaldoCashback().then( (cashback: any) => {
        this.cashback = cashback;
        if(this.cashback){
          let valorPedido = this.pedido.obtenhaTotalSemTaxaEntrega();
          this.setPodeUsarCashback(valorPedido);
        }
      })
    }
  }

  deveExibirTopo() {
    return false;
  }

  deveExibirMenu() {
    return false;
  }

  deveTerBordas() {
    return true;
  }

  mudouFormaPagamento() {
    this.carrinhoService.salvePedido(this.pedido);
  }

 async informouCpf(){
    if(this.pedido.contato.id && !this.pedido.contato.completarCadastro) return;

    let resposta = await   this.clienteService.obtenhaCadastroCompletarPeloCpf(this.pedido.contato.cpf).catch((e) => {
      console.error(e);
    });

    this.buscando = false;
    if (resposta  && resposta.id){
     this.pedido.contato.id = resposta.id
     this.pedido.contato.completarCadastro = true;
     this.criarConta = true;
    } else {
       if( this.pedido.contato.completarCadastro){
         delete  this.pedido.contato.id
         delete  this.pedido.contato.completarCadastro;
         this.criarConta = false;
       }
    }
  }

  informouTelefone() {
    this.buscando = true;
    this.clienteService.obtenhaClientePorTelefone(this.pedido.contato.telefone).then(resposta => {
      this.buscando = false;
      if (resposta  && resposta.id) {
         Object.assign(this.pedido.contato , resposta)
        if(this.pedido.contato.dataNascimento)
          this.pedido.contato.dataNascimento = new Date(this.pedido.contato.dataNascimento)
      } else {
        this.pedido.contato = {
          telefone: this.pedido.contato.telefone,
          codigoPais: this.pedido.contato.codigoPais
        }
      }

      if(resposta.fidelidadeExterna)
        this.setOptinFidelidadExterna( resposta.fidelidadeExterna)

      this.setCashbackDoPagamento();

    }).catch(() => {
      this.buscando = false;
    })
  }

  setOptinFidelidadExterna(fidelidadeExterna: any){
    this.fidelidadeExterna.aceitarFidelidade = fidelidadeExterna.aceitarFidelidade
    this.fidelidadeExterna.id_cliente = fidelidadeExterna.id_cliente
    this.fidelidadeExterna.optin = this.fidelidadeExterna.aceitarFidelidade;
  }

  calculeTroco($event: any) {
    setTimeout(() => {
      this.pedido.calculeTroco();
    }, 0);
  }

  abraModalEscolherEndereco() {
    let altura = window.innerHeight - 100;

    if( this.isMobile ) {
      altura = window.innerHeight;
    }

    const windowRef = this.dialogService.open({
      title: 'Cadastro de Endereço',
      content: ModalEscolherEnderecoComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: altura
    });

    const telaProduto: ModalEscolherEnderecoComponent = windowRef.content.instance;
    telaProduto.window = windowRef;
    telaProduto.pedido = this.pedido;

    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = "17px";
    const $elemento: HTMLElement = document.querySelector('.carrinho_desktop .is-sticky');

    if( $elemento ) $elemento.style.paddingRight = '17px';

    windowRef.result.subscribe(async (endereco: any) => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
      if( $elemento ) $elemento.style.paddingRight = '';
      if (endereco && endereco.cidade) {
        this.pedido.entrega.setTaxaEntrega(endereco, null);
        this.pedido.calculeTotal();

        this.pedido.novosEnderecos.push(endereco);
        this.carrinhoService.salvePedido(this.pedido);

        let codigopromo = this.pedido.cupom ? this.pedido.cupom.codigo : null;

        if(codigopromo)
          await     this.carrinhoService.atualizeValorDesconto(codigopromo, this.empresa);

      }
    });
  }

  alterouFormaEntrega(formaEntrega: any) {
    if (this.pedido.entrega.ehRetirada()) {
      this.pedido.entrega.taxaDeEntrega = 0;
    } else if (this.pedido.entrega.endereco) {
      this.pedido.entrega.taxaDeEntrega = this.pedido.entrega.endereco.taxaDeEntrega;
    }

    if(!this.empresa.apenasAgendamento) {
      this.agendarEntrega = formaEntrega.agendamentoObrigatorio;
      this.apenasAgendamento = formaEntrega.agendamentoObrigatorio;
    }

    this.pedido.calculeTotal();

    if(this.pedido.temValorMinimoDaFormaEscolhida(this.formasDeEntrega)){
      if (this.pedido.entrega.ehDelivery() && !this.pedido.entrega.endereco) {
        if(!this.pedido.ultrapassouValorMaximoDaFormaEscolhida(this.formasDeEntrega))
          this.abraModalEscolherEndereco();
      }
    }

    this.carrinhoService.salvePedido(this.pedido);

  }

  selecioneTudo() {
    if (this.pedido.pagamento.trocoPara > 0) {
      this.txtTrocoM.nativeElement.select();
      this.selecionou = true;
    }
  }

  limpeSeTiverFoco(valor: any) {
    if (!this.selecionou)
      return;

    this.selecionou = false;
    this.pedido.pagamento.trocoPara = 0;
  }

  gereLinkPagamento(){
    delete  this.msgErroLink;
    $("#alertaGerandoPagamento").modal();
    this.pedidosService.gereLinkPagamento(this.pedido).then((res: any) => {
      this.pedido.linkPagamento = res.link;
      this.carrinhoService.salvePedido(this.pedido);
      window.location.href = res.link;
    }).catch((erro) => {
      console.log(erro)
      alert(erro)
      this.msgErroLink = erro;
    });
  }

  facaLoginGuest(resposta: any){
    if(!resposta.fezLoginGuest) return Promise.resolve();

    return this.autorizacao.atualizeUsuarioLogado().then( () => {
      Promise.resolve()
    });
  }


  posicioneNoComplemento(campoAdicional) {
    /*
    const $controleAdicional = document.getElementById('adicional_' + campoAdicional.id);

    if( !$controleAdicional ) {
      return;
    }

    const topo = $controleAdicional.offsetTop - 10;

    document.querySelector('.k-content').scrollTo(0, topo);
     */
  }

  fazerPedido() {
    this.msgErro = null;
    if(this.eviandoPedido) return;

    if (this.frm.valid) {
      this.eviandoPedido = true;

      if(!this.agendarEntrega) {
        this.pedido.dataEntrega = null;
        this.pedido.horarioEntrega = null;
      }

      if(this.fidelidadeExterna){
        if(this.fidelidadeExterna.optin){
          this.pedido.fidelidadeGcom = { id_cliente: this.fidelidadeExterna.id_cliente}
        } else {
          delete   this.pedido.fidelidadeGcom
        }
      }

      this.pedidosService.salvePedido(this.pedido.obtenhaDadosEnvio(this.empresa)).then((resposta) => {
        this.pedido.codigo = resposta.codigo;
        this.pedido.guid = resposta.guid;
        this.eviandoPedido = false;
        this.panelCarrinho.finalizouPedido();

        if(this.pedido.usandoCashbackNoPagamento())
          localStorage.recarregarSaldo =  true;

        this.autorizacaoLojaService.sessao$.subscribe( (idSessao: string) => {
          if (typeof fbq !== 'undefined') {
            const idEvento = idSessao + '-' + resposta.codigo;
            fbq('track', 'Purchase', {
              value: this.pedido.total,
              currency: 'BRL',
              order_id: resposta.id
            }, {
              eventID: idEvento
            });
          }
        });

        if( typeof gtag !== 'undefined' ) {
          const items = this.pedido.itens.map(item => {
            return {
              id: item.produto.id,
              name: item.produto.nome,
              category: item.produto.categoria ? item.produto.categoria.nome : 'Sem Categoria',
              quantity: item.qtde,
              price: item.total / item.qtde
            }
          });

          gtag('event', 'purchase', {
            currency: 'BRL',
            transaction_id: resposta.guid,
            value: this.pedido.total,
            items: items
          });
        }

        this.facaLoginGuest(resposta).then( () => {
          if(resposta.gerarLinkPagamento) {
            this.pedido.gerarLinkPagamento = true;
            this.carrinhoService.salvePedido(this.pedido);
            this.gereLinkPagamento();
          } else {
            if(resposta.abrirUrl)
              window.open(  this.urlWhatsapp );

            let state = { empresa: this.empresa, urlAbrir: resposta.urlAbrir,
              falhaNoPagamentoOnline: resposta.falhaNoPagamentoOnline,
              mensagemFalhaPagamento: resposta.mensagemFalhaPagamento
            };

            this.carrinhoService.salveUltimoPedido(state);
            this.dominiosService.vaParaTelaAcompanharPedido(this.pedido);
          }
        })


      }).catch((erro) => {
        this.eviandoPedido = false;
        this.msgErro = erro;
      });
    } else {
      this.msgErro = 'Preencha os campos obrigatórios'

      setTimeout(() => {

        const $erros: any = document.getElementsByClassName('invalid-feedback');

        if($erros && $erros.length){
          let elmentoErro =  $erros[0];
          if(elmentoErro.parentElement.className.indexOf('input-group') >= 0)
            elmentoErro = elmentoErro.parentElement

          if(elmentoErro.parentElement.className.indexOf('form-group') >= 0)
            elmentoErro = elmentoErro.parentElement

          const topo =  elmentoErro.offsetTop - 40;
          window.scrollTo(0, topo);
        }


      }, 50)
    }
  }

  novoPedido() {
    this.abraTelaLoja();

  }

  abraTelaLoja() {
    this.dominiosService.vaParaHome()
  }

  exibirCriarConta() {
    this.criarConta = true;
  }

  exibirSenhaTela() {
    this.exibirSenha = !this.exibirSenha;
  }

  canceleCriarConta() {
    this.criarConta = false;
  }

  obtenhaTotalPagar() {
    if(!this.cashback || !this.cashback.usar)
      return this.pedido.total;

    let totalPagar = this.pedido.total - this.cashback.valor;

    if(totalPagar < 0) totalPagar = 0;

    return Number(totalPagar.toFixed(2));
  }

  alterouUsarSaldo() {
    if(this.cashback && this.cashback.usar){
      if( this.cashback.saldo  ){
        this.pedido.cashback = this.cashback;
        this.pedido.calculeTotal();
        this.pedido.calculeTroco();
      } else {
        let usuario = this.autorizacao.getUsuario();

        if(!usuario){
          if(this.pedido.contato.id)
            this.abraModalLogin();
          else
            CadContatoLojaComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
              this.dialogService, this.pedido.contato);

        } else {
          if(this.cashback.fazerOptin){
            this.abraModalFazerOptin();
          } else {
            if(!usuario.cpf)
              this.abraModalAtualizarCadastro();
          }
        }
      }
    } else {
      delete this.pedido.cashback
      this.pedido.calculeTotal();
    }

    this.carrinhoService.salvePedido(this.pedido);
  }

  abraModalFazerOptin(){
    this.pedido.contato.fazerOptin = true;
    CadContatoLojaComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
      this.dialogService, this.pedido.contato);

    return false;
  }

  abraModalLogin(){
    let telefone = this.pedido.contato ? this.pedido.contato.telefone : null;
    PainelLoginComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
      this.dialogService, telefone , (result) => {
        if(result && result.login){
          let usuario = this.autorizacao.getUsuario();

          if(usuario && usuario.id){
            this.pedido.contato = usuario;
            this.carrinhoService.salvePedido(this.pedido);
            this.setCashbackDoPagamento()
          }
        }
      });

    return false;
  }

  abraModalAtualizarCadastro(){
    this.pedido.contato.atualizarCadastro = true;
    CadContatoLojaComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
      this.dialogService, this.pedido.contato, (result) => {
        if(result && result.id){
          this.setCashbackDoPagamento()
        }
      }) ;

    return false;
  }

  meioOnlineExigeCartao(forma: FormaDePagamento){
    if(!forma || !forma.configMeioDePagamento) return false;

    return forma.configMeioDePagamento.meioDePagamento === EnumMeioDePagamento.Pagseguro ||
      forma.configMeioDePagamento.meioDePagamento === EnumMeioDePagamento.Pagarme ||
      forma.configMeioDePagamento.meioDePagamento === EnumMeioDePagamento.CieloCheckout ||
      forma.configMeioDePagamento.meioDePagamento === EnumMeioDePagamento.MercadoPago
  }

  escolheuFormaDePagamentoOnline(forma: FormaDePagamento) {
    this.pedido.calculeTotal();
    if (typeof fbq !== 'undefined')
      fbq('track', 'AddPaymentInfo');

    if(this.meioOnlineExigeCartao(forma))
      this.trocarCartao();
  }

  trocarCartao() {
    this.exigeCartao = true;

    if( !this.pedido.entrega.formaDeEntrega ) {
      return;
    }

    const windowRef = TelaCartaoDeCreditoComponent.abraComoPopup(this.dialogService, this.isMobile, this.pedido,
      this.pedido.pagamento, this.dadosCartao);
    this.telaPagamento = windowRef.content.instance;

    windowRef.result.subscribe((result: any) => {
      if( result instanceof DialogCloseResult) {

      } else if (result) {
        this.dadosCartao = result;
        this.pedido.pagamento.dadosCartao = (result as DadosCartao).outroSemDadosSensitivos();

        Object.keys(this.frm.controls).forEach(key => {
          this.frm.controls[key].updateValueAndValidity();
        });
      }
    });

    this.app.tick();
  }

  escolheuFormaDePagamentoPresencial(formaDePagamento: any) {
    this.exigeCartao = false;
    this.pedido.calculeTotal();
    this.mudouFormaPagamento()

    if (typeof fbq !== 'undefined')
      fbq('track', 'AddPaymentInfo');

  }

  mudouPrecisaTroco(formaDePagamento){

  }

  private obtenhaFormasDeEntrega(formasDeEntrega: Array<any>) {
    const formas = [];

    for(let formaEntrega of formasDeEntrega) {
      if( !this.pedido.entrega.permiteEntrega ) {
        if( formaEntrega.formaDeEntrega.nome === FormaDeEntrega.RECEBER_EM_CASA ) {
          continue;
        }
      }

      formas.push(formaEntrega);

      if(formaEntrega.permiteComerNoLocal){
        let formaComerNoLocal = Object.assign({}, formaEntrega);

        formaComerNoLocal.comerNoLocal = true;
        formaComerNoLocal.nome = 'Comer no local';

        formas.push(formaComerNoLocal)
      }
    }

    return formas;
  }

  alterouFormaDePagamentoParaPix() {
    this.exigeCartao = false;
    this.pedido.pagamento.dadosPix = new DadosPix();

    this.alterouFormaDePagamento();

    setTimeout( () => {
      this.txtEmailPix.nativeElement.focus();
    }, 100);
  }

  alterouFormaDePagamento() {
    if(this.cashback && this.cashback.usar)
      this.pedido.cashback = this.cashback

    this.pedido.calculeTotal();
    delete  this.pedido.cashback;
  }

  deveExibirBannerTema() {
    return false;
  }

  alterouOptinFidelidade(){
  //  this.criarConta = this.cashback.optin;
  }

  obtenhaSaldo() {
    let descricao = formatCurrency(this.cashback.saldo, this.locale, "R$")

    if(this.empresa.integracaoFidelidade && this.empresa.integracaoFidelidade.sistema === 'gcom')
      descricao = descricao.replace('R$', this.empresa.idRede === 2 ? "R$G" : "R$C")


    return descricao;
  }



  exibirDadosCliente(){
    let usuario = this.autorizacao.getUsuario();

    if(!usuario || !usuario.id) return true;

    if(this.informarCpf) return  !usuario.cpf

    return  false;
  }

  onCountrySelected($event: any) {
    this.pedido.contato.codigoPais = $event;
    console.log("setou código país. Contato: ", this.pedido.contato)
  }

  onPhoneMaskChange($event: string) {
    this.phoneMask = $event;
    if(this.txtTelefone)
      this.txtTelefone.updateValue(this.txtTelefone.input.nativeElement.value);
  }

  estaHabilitado(formaDePagamento: FormaDePagamento, pedido: PedidoLoja) {
    if(!pedido.entrega || !pedido.entrega.foiPreenchida())
      return formaDePagamento.habilitarEntrega && formaDePagamento.habilitarRetirada;


    if(pedido.entrega?.ehDelivery() && formaDePagamento.habilitarEntrega ) return true;

    if(pedido.entrega?.ehRetirada() && formaDePagamento.habilitarRetirada) return true;

    return false;
  }
}

